import { ApiRequest } from 'app/common/types'

interface SpentsGetContent {
  signalId: string
}

export type SpentsGetRequest = ApiRequest<SpentsGetContent>

export interface SpentEntity {
  date: string
  spend: number
}

export interface TreatmentEntity {
  treatmentName: string
  spends: SpentEntity[]
  totalSpend: number
}

export interface SpentsGetResponse {
  data: {
    totalSpend: number
    treatments: TreatmentEntity[]
  }
}

export type TreatmentSpent = {
  name: string
  spent: number
}

export type DaySpent = {
  date: Date
  spent: number
}

const mapTreatmentSpent = (treatmentEntity: TreatmentEntity): TreatmentSpent => ({
  name: treatmentEntity.treatmentName,
  spent: treatmentEntity.totalSpend,
})

export const mapTreatmentSpents = (treatmentEntities: TreatmentEntity[]): TreatmentSpent[] =>
  treatmentEntities.map(mapTreatmentSpent)

export const mapDaySpents = (treatmentEntities: TreatmentEntity[]): DaySpent[] =>
  treatmentEntities.reduce((acc, current) => {
    current.spends.forEach((spend) => {
      const spentDate = new Date(spend.date)
      const daySpent = acc.find((a) => a.date.getTime() === spentDate.getTime())
      if (!daySpent) {
        acc.push({ date: spentDate, spent: spend.spend })
      } else {
        daySpent.spent += spend.spend
      }
    })

    return acc
  }, [] as DaySpent[])
